import { render, staticRenderFns } from "./donut-chart-card.vue?vue&type=template&id=41a8c206&scoped=true"
import script from "./donut-chart-card.ts?vue&type=script&lang=ts&external"
export * from "./donut-chart-card.ts?vue&type=script&lang=ts&external"
import style0 from "./donut-chart-card.scss?vue&type=style&index=0&id=41a8c206&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8c206",
  null
  
)

export default component.exports